import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button } from 'antd';
import TimePicker from './TimePicker';
import InputField from '../../common/InputField';
import { Input } from 'antd';
import {numberValidation} from "../../../helper/FeildValidations";

const TimeRangePicker = ({
  endLimit,
  index,
  pickers,
  setTimePicker,
  value = {},
  onChange,
  day,
  isEdit,
  step=60,
  daily,
  block,
}) => {
  const [startTime, setStartTime] = useState(
    pickers.length > 1 && pickers[index - 1]?.endTime
      ? moment(pickers[index - 1].endTime, 'h:mm a')
          .add(1, 'hour')
          .format('h:mm a')
      : '7:00 am'
  );
  const [endTime, setEndTime] = useState(endLimit);
  const [pricePerHour, setPricePerHour] = useState();
  useEffect(() => {
    if(isEdit){
      setStartTime(value.startTime);
      setEndTime(value.endTime);
      setPricePerHour(value.pricePerHour)
    }
  }, []);

  useEffect(() => {
    const time = { startTime, endTime };
    handleTimeValueChange(index, time);
  }, [startTime, endTime]);

  const handleTimeValue = picker => {
    const filteredList = pickers
      .filter((pick, index) => index !== picker)
      .map((timePicker, index) => {
        return timePicker;
      });
    setTimePicker(day, filteredList);
  };

  const handleTimeValueChange = (timeIndex, time) => {
    const filteredPickers = pickers.map((other, index) => {
      if (index === timeIndex) {
        return time;
      } else {
        return other;
      }
    });
    setTimePicker(day, filteredPickers);
  };

  const triggerChange = changedValue => {
    if (onChange) {
      onChange({
        startTime,
        endTime,
        ...value,
        ...changedValue
      });
    }
  };
  const handleTimeChange = value => {
    setStartTime(value);
    let pickerList = pickers.slice();
    pickerList[index].startTime = value;
    triggerChange({ startTime: value });
  };

  const handleEndTimeChange = value => {
    setEndTime(value);
    let pickerList = pickers.slice();
    pickerList[index].endTime = value;
    triggerChange({ endTime: value });

    // setTimePicker(pickerList);
  };

  const priceChange = (value) =>{
    const convertedValue = parseFloat(value.pricePerHour);
    if(!value.pricePerHour) {
      triggerChange(null)
      setPricePerHour(null)
      }
      else if(numberValidation(convertedValue)){
      triggerChange(value)
      setPricePerHour(convertedValue)
      }else{
      triggerChange(pricePerHour)
      }
      }


  return (
    <div className="start-end-wrapper">
      <div className="start-end-inner-wrapper">
        <TimePicker
          label={'Start'}
          value={startTime}
          beginLimit="6:00 am"
          onChange={value => {
          handleTimeChange(value)}}
          endLimit={
            endTime
              ? moment(endTime, 'h:mm a')
                  .add(-1, 'hour')
                  .format('h:mm a')
              : '10:00 pm'
          }
          name={'startTime'}
          updatedStartTime={index === 0 ? null : pickers[index - 1]?.endTime}
          step={step}
        />
        <TimePicker
          label={'End'}
          value={endTime}
          beginLimit={
            startTime
              ? moment(startTime, 'h:mm a')
                  .add(1, 'hour')
                  .format('h:mm a')
              : '7:00 am'
          }
          onChange={value => handleEndTimeChange(value)}
          endLimit={'11:00 pm'}
          name={'endTime'}
          step={step}
        />
        <Input placeholder={daily?'Price Per Day':block?'Price Per Block':'Price Per Hour'} type="number" onChange={e => priceChange({ pricePerHour: e.target.value })} value={pricePerHour}/>
        {index !== 0 && (
          <Button className="minus-btn hourly-duration" onClick={() => handleTimeValue(index)}>
            {' '}
            -{' '}
          </Button>
        )}
        {index === 0 && (
          <Button
            className="plus-btn hourly-duration"
            onClick={() =>
              setTimePicker(day, [...pickers, { startTime: '8:00 am', endTime: '11:00 pm' }])
            }
          >
            +
          </Button>
        )}
      </div>
    </div>
  );
};

TimeRangePicker.propTypes = {
  endLimit: PropTypes.string,
  pickers: PropTypes.array,
  setTimePicker: PropTypes.func
};

export default TimeRangePicker;
